import { Box, Dialog, DialogProps } from '@medely/web-components';
import React from 'react';
import useProfessionalQualifications from 'hooks/useProfessionalQualifications';
import FacilityOnboarding from 'routes/jobs/components/JobDetails/FacilityOnboarding';
import { CredentialStatus, IProfessionalQualification } from '@medely/types';
import { expirationDateExpiringSoon } from '@mp';

interface FacilityOnboardingModalProps extends DialogProps {
  credential: IProfessionalQualification;
  source?: string;
}

const EDITABLE_STATUSES: CredentialStatus[] = ['rejected', 'review', 'incomplete'];

const FacilityOnboardingModal = ({
  credential,
  source = 'credential',
  open,
  onClose,
}: FacilityOnboardingModalProps): React.ReactElement => {
  const { editProfessionalQualification, submitProfessionalQualification } =
    useProfessionalQualifications();

  const completed = credential?.status === 'approved';
  const canAttest = !completed || expirationDateExpiringSoon(credential);

  const onEditFacilityOnboarding = () =>
    editProfessionalQualification(
      {
        id: credential.id,
        professional_qualification: {
          professional_qualification_attributes_attributes: [
            {
              qualification_attribute_slug: 'sca_group_facility_onboarding_signed_attestation',
            },
          ],
        },
      },
      { onSuccess: onClose },
    );

  const onSubmitFacilityOnboarding = () =>
    submitProfessionalQualification(
      {
        professional_qualification: {
          qualification_id: credential.qualification.id,
          professional_qualification_attributes_attributes: [
            {
              qualification_attribute_slug: 'sca_group_facility_onboarding_signed_attestation',
            },
          ],
        },
      },
      { onSuccess: onClose },
    );

  const onboardingAttestation = () => {
    EDITABLE_STATUSES.includes(credential.status)
      ? onEditFacilityOnboarding()
      : onSubmitFacilityOnboarding();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" title={'SCA Health'}>
      <Box p={3} pb={2}>
        <FacilityOnboarding
          source={source}
          documents={credential?.qualification?.conditions?.[0]?.condition_documents || []}
          attributes={credential?.professional_qualification_attributes}
          canAttest={canAttest}
          completed={completed}
          onButtonClick={onboardingAttestation}
        />
      </Box>
    </Dialog>
  );
};

export default FacilityOnboardingModal;
